import { render, staticRenderFns } from "./AddAdvertise.vue?vue&type=template&id=2b809219&scoped=true&"
import script from "./AddAdvertise.vue?vue&type=script&lang=js&"
export * from "./AddAdvertise.vue?vue&type=script&lang=js&"
import style0 from "./AddAdvertise.vue?vue&type=style&index=0&id=2b809219&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b809219",
  null
  
)

export default component.exports